var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfiCrmNewLoginLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u0428\\u0430\\u0440_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 790.58 218.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#_New_gradient-1-3);}.cls-2{fill:#0315e7;}.cls-3{fill:url(#_New_gradient-1);}.cls-4{fill:url(#_New_gradient-1-2);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_New_gradient-1",
    x1: 56.58,
    y1: 220.16,
    x2: 56.58,
    y2: 63.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0315e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#1b2ae6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#323ce6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#3f48e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#444ce6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_New_gradient-1-2",
    x1: 109.05,
    y1: 221.01,
    x2: 109.05,
    y2: 45.06,
    xlinkHref: "#_New_gradient-1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_New_gradient-1-3",
    x1: 161.52,
    y1: 221.26,
    x2: 161.52,
    y2: 39.74,
    xlinkHref: "#_New_gradient-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u0428\\u0430\\u0440_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m246.32,144.99v-70.65h39.38c6.28,0,11.57.85,15.88,2.56,4.31,1.7,7.58,4.21,9.82,7.52,2.24,3.31,3.36,7.4,3.36,12.28s-1.12,8.9-3.36,12.28c-2.24,3.37-5.51,5.93-9.82,7.67-4.31,1.74-9.61,2.61-15.88,2.61h-24.45v25.76h-14.93Zm14.93-37.18h22.55c5.55,0,9.64-.89,12.28-2.66,2.64-1.77,3.96-4.59,3.96-8.47s-1.29-6.65-3.86-8.32c-2.57-1.67-6.7-2.5-12.38-2.5h-22.55v21.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m326.89,144.99v-49.51h13.33v12.43h-.7c1.4-4.07,3.91-7.22,7.52-9.42,3.61-2.2,8.05-3.47,13.33-3.81l5.31-.4,1.1,12.33-9.12.8c-5.48.47-9.57,1.79-12.28,3.96-2.71,2.17-4.06,5.03-4.06,8.57v25.05h-14.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m403.86,145.99c-6.48,0-12.06-1.1-16.74-3.31-4.68-2.2-8.25-5.24-10.72-9.12-2.47-3.87-3.71-8.32-3.71-13.33s1.24-9.54,3.71-13.38c2.47-3.84,6.05-6.86,10.72-9.07,4.68-2.2,10.25-3.31,16.74-3.31s12.23,1.1,16.84,3.31c4.61,2.21,8.15,5.23,10.62,9.07,2.47,3.84,3.71,8.3,3.71,13.38s-1.22,9.46-3.66,13.33c-2.44,3.88-5.98,6.92-10.62,9.12-4.65,2.2-10.27,3.31-16.89,3.31Zm0-11.02c5.41,0,9.59-1.37,12.53-4.11,2.94-2.74,4.41-6.31,4.41-10.72s-1.47-7.93-4.41-10.57c-2.94-2.64-7.12-3.96-12.53-3.96s-9.59,1.32-12.53,3.96-4.41,6.16-4.41,10.57,1.47,7.98,4.41,10.72c2.94,2.74,7.12,4.11,12.53,4.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m452.86,144.99v-39.08h-12.03v-10.42h15.43l-3.41,3.41v-2.71c0-6.81,2.17-12.04,6.51-15.68,4.34-3.64,10.89-5.76,19.64-6.36l6.31-.4,1,10.82-6.71.3c-2.87.13-5.23.54-7.06,1.2-1.84.67-3.21,1.62-4.11,2.86-.9,1.24-1.35,2.92-1.35,5.06v4.71l-4.01-3.21h44.7v49.51h-14.33v-39.08h-26.26v39.08h-14.33Zm39.79-59.53v-13.33h15.83v13.33h-15.83Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m566.51,145.99c-8.55,0-16.02-1.45-22.4-4.36-6.38-2.91-11.31-7.08-14.78-12.53-3.47-5.44-5.21-11.91-5.21-19.39s1.75-13.95,5.26-19.39c3.51-5.44,8.43-9.64,14.78-12.58,6.35-2.94,13.83-4.41,22.45-4.41,6.28,0,12.01.75,17.19,2.26,5.18,1.5,9.57,3.79,13.18,6.86l-5.31,11.22c-3.74-2.67-7.55-4.63-11.42-5.86-3.87-1.24-8.22-1.85-13.03-1.85-8.62,0-15.35,2.04-20.19,6.11-4.84,4.08-7.26,9.96-7.26,17.64s2.41,13.46,7.22,17.54c4.81,4.08,11.56,6.11,20.24,6.11,4.81,0,9.15-.62,13.03-1.85,3.87-1.23,7.68-3.19,11.42-5.86l5.31,11.22c-3.61,3.01-8.02,5.28-13.23,6.81-5.21,1.54-10.96,2.31-17.24,2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m613.1,144.99v-70.65h39.08c9.49,0,16.74,1.79,21.75,5.36,5.01,3.57,7.52,8.77,7.52,15.58,0,4.41-1.09,8.13-3.26,11.17-2.17,3.04-5.29,5.41-9.37,7.11-4.08,1.7-8.99,2.69-14.73,2.96l.9-.9,3.61.1c2.74.13,5.19.82,7.36,2.05s4.19,3.16,6.06,5.76l14.93,21.45h-16.53l-14.43-21.25c-1-1.47-2.02-2.62-3.06-3.46-1.04-.83-2.34-1.44-3.91-1.8-1.57-.37-3.63-.55-6.16-.55h-14.83v27.06h-14.93Zm14.93-37.98h22.65c5.68,0,9.79-.9,12.33-2.71,2.54-1.8,3.81-4.51,3.81-8.12s-1.29-6.15-3.86-7.82c-2.57-1.67-6.73-2.5-12.48-2.5h-22.45v21.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m700.79,144.99v-70.65h14.43l31.87,46.8h-2.61l31.57-46.8h14.53v70.65h-13.93v-51.41h1.3l-27.86,40.39h-8.92l-27.96-40.49h1.5v51.51h-13.93Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m109.05,6.93c5.65,0,11.3,2.15,15.61,6.46l80.06,80.06c8.62,8.62,8.62,22.59,0,31.21l-80.06,80.06c-4.31,4.31-9.96,6.46-15.61,6.46s-11.3-2.15-15.61-6.46L13.38,124.67c-8.62-8.62-8.62-22.59,0-31.21L93.44,13.39c4.31-4.31,9.96-6.46,15.61-6.46m0-6.93c-7.75,0-15.03,3.02-20.51,8.49L8.48,88.56c-11.31,11.31-11.31,29.7,0,41.01l80.06,80.06c5.48,5.48,12.76,8.49,20.51,8.49s15.03-3.02,20.51-8.49l80.06-80.06c11.31-11.31,11.31-29.7,0-41.01L129.55,8.49c-5.48-5.48-12.76-8.49-20.51-8.49h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "34.02 111.87 34.02 145.3 79.14 190.43 79.14 111.87 34.02 111.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m86.49,58.73v139.04l6.96,6.96c8.62,8.62,22.59,8.62,31.21,0l6.96-6.96V58.73h-45.12Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "138.96 5.52 138.96 190.43 184.08 145.3 184.08 5.52 138.96 5.52"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfiCrmNewLoginLogo);
export default __webpack_public_path__ + "static/media/profi-crm-new-login-logo.040073df6181ec2f9788f75c073e561b.svg";
export { ForwardRef as ReactComponent };